import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { FeatureDetailsResponse, getFeatureDetails } from 'services';

export type State = ApiState<FeatureDetailsResponse, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchFeatureDetails = createAsyncThunk('get/featureDetails', async () => await getFeatureDetails());

export const initialState = {
  isLoading: false,
  hasLoaded: false,
  //data: {},
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const featureDetailsSlice = createSlice({
  name: 'featureDetails',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchFeatureDetails.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchFeatureDetails.fulfilled, (state, action: PayloadAction<FeatureDetailsResponse>) => {
      state.isLoading = false;
      state.data = action.payload;
      state.hasLoaded = true;
    });

    builder.addCase(fetchFeatureDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const stateSelector_ = (state: { featureDetails: State }): State => state.featureDetails;

export const featureDetails_ = createSelector(stateSelector_, (state) => state.data);

export default featureDetailsSlice.reducer;
